import { useEffect } from 'react';

interface DocumentMeta {
  title: string;
  description: string;
  robots?: string;
  canonical?: string;
}

/** Unmount restores the previous title and forces robots to noindex. */
export function useDocumentMeta({ title, description, robots = 'index, follow', canonical }: DocumentMeta) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, attr = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      return el;
    };

    setMeta('description', description);
    setMeta('robots', robots);

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
      setMeta('og:url', canonical, 'property');
    }

    return () => {
      document.title = prevTitle;
      setMeta('robots', 'noindex, nofollow');
    };
  }, [title, description, robots, canonical]);
}
